import { Link } from '@tanstack/react-router';
import { CircleArrowLeft } from 'lucide-react';

import { ParentsOnboardingBatchesTable } from './parents-onboarding-batches-table';

export const ParentsOnboardingBatchesPage = () => {
  return (
    <div className='pt-4'>
      <Link
        className='mb-8 flex w-fit items-center gap-2'
        to='/parents/bulk-upload'
      >
        <CircleArrowLeft className='size-6' />
        <span className='text-lg font-semibold'>Back</span>
      </Link>

      <div className='border-t px-4 pt-8'>
        <ParentsOnboardingBatchesTable />
      </div>
    </div>
  );
};
